@if (form) {
  <form [formGroup]="form" [attr.autocomplete]="'off'">
    <div class="form-row">
      <mat-form-field [appearance]="appearance">
        @if (showLabel) {
          <mat-label>{{ installatoerLabel }}</mat-label>
        }
        <mat-chip-grid #chipList aria-label="Installatør selection">
          @for (installatoer of selectedInstallatoer; track installatoer) {
            <mat-chip-row [removable]="removable" (removed)="removeInstallatoer()">
              {{ installatoer }}
              @if (removable) {
                <mat-icon matChipRemove>cancel</mat-icon>
              }
            </mat-chip-row>
          }
          <input
            matInput
            #installatoerInput
            [formControl]="installatoerCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addInstallatoer($event)"
            matChipInputAddOnBlur="true"
            />
          </mat-chip-grid>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            @for (installatoer of filteredInstallatoerer | async; track installatoer) {
              <mat-option [value]="installatoer">
                {{ installatoer }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </form>
  }
